import { HTTP } from '@/http/http-client';

const getAllPaymentMethods = (parentId, schoolId) =>
    HTTP.get(`payments/method/${parentId}/${schoolId}/all`).then(({ data }) => data);

const getClientSecret = (parentId, schoolId) =>
    HTTP.post(`payments/method/${parentId}/${schoolId}`).then(({ data }) => data);

const createPayment = (payload) => 
    HTTP.post(`payments/create`, {
        ...payload,
        paymentType: 'CHARGE'
    }).then(({ data }) => data);

const confirmPayment = (paymentId) => 
    HTTP.post(`payments/${paymentId}/confirm`, {}).then(({ data }) => data);

const deletePaymentMethod = (parentId, schoolId, paymentMethodId) =>
    HTTP.delete(`payments/method/${parentId}/${schoolId}?payment_method_id=${paymentMethodId}`).then(({ data }) => data);

const applyCoupon = (paymentId, coupon) =>
    HTTP.post(`payments/${paymentId}/coupon/apply?coupon=${coupon}`, {}).then(({ data }) => data);


const getAllCoupons = (schoolId, couponName) =>
    HTTP.get(`schools/coupons/${schoolId}/all?search=${couponName}`).then(({ data }) => data);

const cancelPaymentFlow = (schoolSlug, classId, childId, rosterId) =>
    HTTP.delete(`schools/${schoolSlug}/classes/${classId}/enrollment/${childId}/${rosterId}`).then(({ data }) => data);

const cancelAftercarePaymentFlow = (schoolId, aftercareId,rosterId,childId) =>
    HTTP.delete(`schools/${schoolId}/aftercare/${aftercareId}/rosters/${rosterId}/child/${childId}`).then(({ data }) => data);

const cancelAftercareDropInPaymentFlow = (schoolId, aftercareId, dropInOrderId) =>
    HTTP.delete(`schools/${schoolId}/aftercare/${aftercareId}/drop-in/${dropInOrderId}`).then(({ data }) => data);

const cancelCampPaymentFlow = (schoolId, campPricingId, rosterId) =>
    HTTP.delete(`schools/${schoolId}/camp-pricing/${campPricingId}/rosters/enrollment/${rosterId}`).then(({ data }) => data);

const removeChildWithoutPaymentFromAftercareRosters = (schoolId, roster, childId, rosterDay) =>

    HTTP.delete(`schools/${schoolId}/aftercare-roster/${roster}/aftercare-day/${rosterDay}/children/${childId}/skipped`).then(({ data }) => data);

const removeChildWithoutPaymentFromClass = (schoolId, classId, rosterId, childId) =>
    HTTP.delete(`schools/${schoolId}/classes/${classId}/rosters/${rosterId}/children/${childId}/skipped`).then(({ data }) => data);

const removeChildWithoutPaymentFromCamp = (schoolId, campPricingId, rosterId, childId) =>
    HTTP.delete(`schools/${schoolId}/camp-pricing/${campPricingId}/rosters/${rosterId}/children/${childId}/skipped`).then(({ data }) => data);

const setDefaultPaymenyMethod = (parentId, schoolId, paymentMethodId) => 
    HTTP.put(`payments/method/${parentId}/${schoolId}/default?payment_method_id=${paymentMethodId}`).then(({ data }) => data);

const addACHBankAccount = (parentId, schoolId) => 
    HTTP.post(`payments/method/${parentId}/${schoolId}/ach`).then(({ data }) => data);

export default {
    cancelPaymentFlow,
    cancelAftercarePaymentFlow,
    getAllPaymentMethods,
    getClientSecret,
    createPayment,
    confirmPayment,
    deletePaymentMethod,
    applyCoupon,
    getAllCoupons,
    setDefaultPaymenyMethod,
    removeChildWithoutPaymentFromClass,
    removeChildWithoutPaymentFromAftercareRosters,
    removeChildWithoutPaymentFromCamp,
    cancelAftercareDropInPaymentFlow,
    cancelCampPaymentFlow,
    addACHBankAccount
};


// WEBPACK FOOTER //
// ./src/http/services/paymentService.js